module.exports = __webpack_public_path__ + "static/media/Sep_2025_5.230fdb9a.webp";